import { useEffect } from 'react';
import { useAppDispatch } from 'src/store/baseHooks';
import { setActiveTabDirtyProperty } from 'src/store/slices/uiFlowSlice';

/**
 *  Handles setting the activeTabIsDirty value in the UI Flow Context.
 *
 * @param isDirty
 */
export const useHandleDirtyFieldFlag = (isDirty: boolean) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setActiveTabDirtyProperty(isDirty));

    return () => {
      dispatch(setActiveTabDirtyProperty(false));
    };
  }, [dispatch, isDirty]);
};
